// extracted by mini-css-extract-plugin
export default {"picture":"styles_picture__MnXYw","initials":"styles_initials__Ec7kV"};